'use strict';

import Promise from 'es6-promise';
import Template from '../template';
import Log from '../log';
import Util from '../util';
import Config from '../config/index';

Template.add('api.kratzbaum.get', Config.api.local + '/kratzbaum/{{base_id}}/{{version}}');
Template.add('api.kratzbaum.create', Config.api.local + '/kratzbaum');
Template.add('api.kratzbaum.addVersion', Config.api.local + '/kratzbaum/{{base_id}}');
Template.add('api.lang.get', Config.api.static + '/lang/{{lang}}.json');

const Actions = {
    'kratzbaum.get': {
        method: 'get',
        url: 'api.kratzbaum.get'
    },
    'kratzbaum.create': {
        method: 'post',
        url: 'api.kratzbaum.create'
    },
    'kratzbaum.addVersion': {
        method: 'post',
        url: 'api.kratzbaum.addVersion'
    },
    'lang.get': {
        method: 'get',
        url: 'api.lang.get'
    }
};

function query(endpoint, data, urlParams) {
    return new Promise((resolve, reject) => {
        let _action = Actions[endpoint],
            url = Template.fill(_action.url, urlParams);
        if(!_action) return reject(`There is no action "${endpoint}"`);

        $.ajax({
            url: url,
            datatype: 'json',
            contentType: 'application/json; charset=utf-8',
            method: _action.method || 'get',
            data: Util.isNull(data) ? null : JSON.stringify(data)
        })
            .done((data, status, jqXHR) => {
                Log.trace(`successfully queried "${url}"`);
                resolve(data)
            })
            .fail((jqXHR, status, err) => {
                Log.error('error while querying api', jqXHR, err);
                reject(err);
            });
    });
}

export default {
    query
}